import React, { Component } from "react";
import Layout from "../../header_footer/Layout";
import Jumbotron from "../../utils/Jumbotron";
import PhotoGallery from "../../utils/PhotoGallery";

import { setWebsiteUrl } from "../../../utils/Utils";

import ExternalLinks from "../../utils/ExternalLinks";

import axios from "axios";
import PropTypes from "prop-types";

const texto = {
  fontSize: "16px",
  lineHeight: "40px",
  color: "#262626",
  marginBottom: "40px",
};

const img = {
  width: "100%",
  marginBottom: "24px",
};

const listItems = {
  listStyleType: "none",
};

const ULItem = {
  padding: "0px",
  marginBottom: "0px",
};

class Restaurante extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      restaurante: {},
    };
  }

  componentDidMount = () => {
    this.loadRestaurante();
  };

  loadRestaurante = async () => {
    let identifier = this.props.match.params.identifier;

    let res = {};
    try {
      res = await axios.get("/api/restaurantes/" + identifier, {
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
        },
      });
    } catch (error) {
      console.log(error);
    }

    if (res.data.restaurante === null) {
      this.context.router.history.push("/not_found");
    }

    let restaurante = res.data.restaurante;
    this.setState({ restaurante });
  };

  render() {
    return (
      <Layout>
        <Jumbotron
          detalhe={"Restaurante"}
          title={this.state.restaurante.name}
        ></Jumbotron>
        <div className="container">
          <div id="detalhe-restaurante" className="row">
            <div className="col-12 col-md-6 container-rich-text-description">
              <p
                style={texto}
                dangerouslySetInnerHTML={{
                  __html: this.state.restaurante.description,
                }}
              />
            </div>

            <div className="offset-md-2 col-12 col-md-4">
              <img
                style={img}
                src={this.state.restaurante.mainPhoto}
                alt="Logotipo Restaurante"
              />


                  <ExternalLinks data={this.state.restaurante} />


              <div className="box-shadow event-details-info">
                <p className="">Pratos Principais</p>

                <ul style={ULItem} className="restaurante-detalhes__ul">
                  {this.state.restaurante.pratos &&
                    this.state.restaurante.pratos.map(function (item) {
                      return (
                        <li style={listItems} key={item}>
                          {item}
                        </li>
                      );
                    })}
                </ul>
              </div>

              {this.state.restaurante.phoneContacts &&
                this.state.restaurante.phoneContacts.length > 0 && (
                  <div className="box-shadow event-details-info">
                    <p className="">Contactos</p>

                    <ul style={ULItem} className="restaurante-detalhes__ul">
                      {this.state.restaurante.phoneContacts.map(function (
                        item
                      ) {
                        return (
                          <li style={listItems} key={item}>
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}

              <div className="box-shadow event-details-info">
                <p>Local</p>
                <p className="texto-detalhes">{this.state.restaurante.local}</p>
              </div>
            </div>
          </div>

          <PhotoGallery photos={this.state.restaurante.photos} />
        </div>
      </Layout>
    );
  }
}

export default Restaurante;
